import type { SVGProps } from "react";

/**
 * pencil-line
 * @category Edit
 */
export default function IconPencilLine(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 24 24' fill='none' aria-hidden {...props}>
      <path
        d='M12.75 21.25H21.25M2.75 17V21.25H7L20.67 7.54001C21.451 6.75896 21.451 5.52106 20.67 4.74001L19.26 3.33001C18.479 2.54896 17.241 2.54904 16.46 3.33009L2.75 17Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
